import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

type HeadFilterMultiSelectFieldProps = {
  filterValue: string | string[];
  setFilterValue: (value: any) => void;
  options: { value: string; label: string }[];
  selectedColumn: { label?: string } | null;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function HeadFilterMultiSelectField({
  filterValue,
  setFilterValue,
  options,
  selectedColumn,
  t,
}: HeadFilterMultiSelectFieldProps) {
  const selectedValues = Array.isArray(filterValue)
    ? filterValue
    : filterValue
      ? filterValue.split(',')
      : [];

  const renderValue = (selected: any) => {
    const selectedArray = Array.isArray(selected) ? selected : selected.split(',');

    if (selectedArray.length === 0) {
      return <Typography variant="body2">{t('SELECT')}</Typography>;
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selectedArray.map((value: string) => {
          const option = options.find((opt) => opt.value === value);
          return <Chip key={value} label={option?.label || value} size="small" />;
        })}
      </Box>
    );
  };

  return (
    <TextField
      select
      fullWidth
      size="small"
      label={`${t('SELECT')} ${selectedColumn?.label}`}
      value={selectedValues}
      onChange={(e) => {
        const value = e.target.value;
        const newValue = Array.isArray(value) ? value.join(',') : value;
        setFilterValue(newValue);
      }}
      SelectProps={{
        multiple: true,
        renderValue,
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Checkbox checked={selectedValues.includes(option.value)} />
          <Typography variant="body2">{option.label}</Typography>
        </MenuItem>
      ))}
    </TextField>
  );
}
